import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import productsData from "../data/mydata.json";

function ProductDetail({ onOpenAuth, onOpenMenu }) {
  const { id } = useParams();

  const product = useMemo(() => {
    if (!id) return null;
    return (
      productsData.find((p) => String(p.pid) === id) ||
      productsData.find((p) => p.sku === id)
    );
  }, [id]);

  const images = product?.images || [];
  const mainImage = images[0];

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto max-w-6xl px-4 py-8 md:px-6">
        {!product && (
          <p className="mt-20 text-center text-sm text-slate-500">
            Product not found. Showing static layout.
          </p>
        )}

        <div className="grid gap-8 md:grid-cols-[280px_minmax(0,1fr)]">
          <div className="space-y-4">
            <div className="flex items-center justify-center rounded-2xl border border-slate-200 bg-white p-4">
              {mainImage ? (
                <img
                  src={mainImage}
                  alt={product?.title || product?.sku}
                  className="max-h-64 object-contain"
                />
              ) : (
                <div className="flex h-64 w-full items-center justify-center rounded-xl bg-slate-100 text-xs text-slate-400">
                  No Image
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2">
              {images.slice(0, 4).map((img, idx) => (
                <div
                  key={idx}
                  className="flex h-16 items-center justify-center rounded-xl border border-slate-200 bg-white"
                >
                  <img
                    src={img}
                    alt={`${product?.title || product?.sku} ${idx + 1}`}
                    className="h-12 object-contain"
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-6 rounded-2xl border border-slate-200 bg-white p-6">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h1 className="text-2xl font-semibold text-slate-900">
                  {product?.title || product?.sku || "Home Chips Crinkle Cut"}
                </h1>
                <div className="mt-2 flex flex-wrap gap-2 text-[11px]">
                  <span className="rounded-full bg-slate-200 px-3 py-1">
                    {product?.packsize || "828ml"}
                  </span>
                  <span className="rounded-full bg-emerald-50 px-3 py-1 text-emerald-600">
                    Vegan
                  </span>
                  <span className="rounded-full bg-amber-50 px-3 py-1 text-amber-600">
                    Vegetarian
                  </span>
                </div>
              </div>

              <div className="rounded-xl bg-emerald-50 px-4 py-2 text-right text-xs">
                <p className="text-[11px] font-semibold text-emerald-600">
                  Best Price
                </p>
                <p className="text-lg font-bold text-emerald-700">
                  £{product?.price || "1.75"}
                </p>
              </div>
            </div>

            <section className="space-y-3">
              <h2 className="text-sm font-semibold text-slate-900">
                Where To Buy
              </h2>
              <div className="space-y-2 text-xs">
                <RetailRow
                  name="TESCO"
                  price={product?.price || "1.98"}
                  active={product?.platform === "tesco"}
                />
                <RetailRow
                  name="Morrisons"
                  price="1.80"
                  active={product?.platform === "morrisons"}
                />
                <RetailRow
                  name="ASDA"
                  price="1.91"
                  active={product?.platform === "asda"}
                />
                <RetailRow
                  name="Sainsbury's"
                  price="1.75"
                  active={product?.platform === "sainsburys"}
                />
              </div>
            </section>

            <section className="space-y-2 text-sm text-slate-700">
              <h2 className="text-sm font-semibold text-slate-900">
                Good to know
              </h2>
              <p className="text-xs text-slate-600">
                {product?.description
                  ? product.description.slice(0, 420)
                  : "Lorem ipsum placeholder text because description is not available for this product in the JSON file."}
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

function RetailRow({ name, price, active }) {
  return (
    <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-4 py-2">
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded-md bg-slate-200" />
        <span className="text-xs font-semibold text-slate-900">{name}</span>
      </div>
      <div className="flex items-center gap-3 text-xs">
        <span className="font-semibold text-slate-900">
          £{price}
        </span>
        <span className="text-yellow-400">★★★★★</span>
        <span className="text-slate-500">15 Reviews</span>
        <button className="rounded-full bg-indigo-600 px-3 py-1 text-[11px] font-semibold text-white">
          + Add →
        </button>
      </div>
    </div>
  );
}

export default ProductDetail;

